import LiveChatIcon from "../../assets/icons/LiveChatIcon";
import styles from "./FloatingChatBtn.module.css";

const FloatingChatBtn = () => {
  return (
    <button className={styles.chatIconWrapper}>
      <LiveChatIcon fill="#fff" />
    </button>
  );
};

export default FloatingChatBtn;
